var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"boxall"},[_c('div',{staticClass:"title"},[_vm._v("溯源管理")]),_c('div',{staticClass:"boxnav"},[_c('div',{staticClass:"bg-image"})])])
}]

export { render, staticRenderFns }